<template>
    <div>
        <slot v-bind="this" />
    </div>
</template>

<script>
    export default {
        props: {
            category: String,
        },
        data() {
            return {
                data: {
                    ...this.$props,
                }
            }
        },
    }
</script>